<template>
  <div class="products-page">
    <DemoModal :show="isModalOpen" :url="brevoLink" @close="closeModal" />
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-container">
        <div class="hero-content">
          <div class="hero-text">
            <h1 class="hero-title">
              Fourin Track: La plataforma inteligente para gestionar el mantenimiento de activos
            </h1>
            <p class="hero-description">
              Gestión de activos, trazabilidad, históricos y sensores inteligentes en una sola
              solución.
            </p>
            <div class="demo-link">
              <button class="btn-demo" @click="openModal">
                <span class="btn-text">Solicita una demo gratuita</span>
                <span class="material-symbols-outlined btn-icon">calendar_month</span>
              </button>
            </div>
          </div>
          <div class="hero-image">
            <div class="platform-preview">
              <img
                src="../assets/images/devices.png"
                alt="Fourin Track Platform"
                class="platform-screenshot"
              />
              <div class="tech-background"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Problem Section -->
    <section class="problem-section">
      <div class="section-container">
        <div class="problem-content">
          <div class="problem-text">
            <h2 class="section-title" style="color: #bc0c0c">El problema</h2>
            <p class="problem-question">¿Tu equipo aún usa Excel o papel para el mantenimiento?</p>
            <ul class="problem-list">
              <li class="problem-item">
                <span class="problem-icon">❌</span>
                Falta de trazabilidad y visibilidad
              </li>
              <li class="problem-item">
                <span class="problem-icon">❌</span>
                Desorden en la operación ralentizada por mala gestión de data
              </li>
              <li class="problem-item">
                <span class="problem-icon">❌</span>
                No poder anticiparse en fallos
              </li>
            </ul>
          </div>
          <div class="problem-image">
            <div class="problem-visual">
              <div class="excel-icon">📊</div>
              <div class="paper-icon">📄</div>
              <div class="confusion-lines"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="features-section">
      <div class="section-container">
        <h2 class="section-title centered">Funcionalidades destacadas</h2>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <span class="material-symbols-outlined">person</span>
            </div>
            <h3 class="feature-title">Gestión de activos</h3>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <span class="material-symbols-outlined">description</span>
            </div>
            <h3 class="feature-title">Registro de mantenimientos</h3>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <span class="material-symbols-outlined">location_on</span>
            </div>
            <h3 class="feature-title">Geolocalización y trazabilidad</h3>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <span class="material-symbols-outlined">group</span>
            </div>
            <h3 class="feature-title">Control de usuarios y roles</h3>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <span class="material-symbols-outlined">admin_panel_settings</span>
            </div>
            <h3 class="feature-title">Control de usuarios y roles</h3>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <span class="material-symbols-outlined">business</span>
            </div>
            <h3 class="feature-title">Multiempresa / Multicliente</h3>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <span class="material-symbols-outlined">integration_instructions</span>
            </div>
            <h3 class="feature-title">Integración con IoT y ERP</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- Pricing Section -->
    <!--   <section class="pricing-section">
      <div class="section-container">
        <div class="pricing-content">
          <div class="pricing-text">
            <h2 class="section-title">Planes y precios</h2>
            <p class="pricing-description">
              Agenda tu demo gratuita y transforma la forma en que gestionas el mantenimiento
            </p>
            <router-link to="/contact" class="demo-link">
              <button class="btn-demo secondary">
                <span class="btn-text">Solicita una demo</span>
                <span class="material-symbols-outlined btn-icon">arrow_forward</span>
              </button>
            </router-link>
          </div>
          <div class="pricing-visual">
            <div class="pricing-chart">
              <div class="chart-bar" style="height: 60%"></div>
              <div class="chart-bar" style="height: 80%"></div>
              <div class="chart-bar" style="height: 100%"></div>
              <div class="chart-bar" style="height: 70%"></div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import DemoModal from './DemoModal.vue'

gsap.registerPlugin(ScrollTrigger)

const isModalOpen = ref(false)
const brevoLink = 'https://meet.brevo.com/angie-marriaga'

const openModal = () => {
  isModalOpen.value = true
}
const closeModal = () => {
  isModalOpen.value = false
}

onMounted(() => {
  // Animaciones de entrada
  gsap.fromTo(
    '.hero-title',
    { opacity: 0, y: 50 },
    { opacity: 1, y: 0, duration: 1, ease: 'power2.out' },
  )

  gsap.fromTo(
    '.hero-description',
    { opacity: 0, y: 30 },
    { opacity: 1, y: 0, duration: 0.8, delay: 0.3, ease: 'power2.out' },
  )

  gsap.fromTo(
    '.btn-demo',
    { opacity: 0, y: 20, scale: 0.9 },
    { opacity: 1, y: 0, scale: 1, duration: 0.6, delay: 0.6, ease: 'back.out(1.7)' },
  )

  gsap.fromTo(
    '.platform-preview',
    { opacity: 0, x: 50, scale: 0.9 },
    { opacity: 1, x: 0, scale: 1, duration: 1, delay: 0.4, ease: 'power2.out' },
  )

  // Animaciones de scroll
  gsap.fromTo(
    '.feature-card',
    { opacity: 0, y: 30, scale: 0.9 },
    {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 0.6,
      stagger: 0.1,
      ease: 'back.out(1.7)',
      scrollTrigger: {
        trigger: '.features-grid',
        start: 'top 80%',
        end: 'bottom 20%',
        toggleActions: 'play none none reverse',
      },
    },
  )
})
</script>

<style scoped>
/* Variables CSS locales */
.products-page {
  --primary-blue: #1297ef;
  --secondary-blue: #4ab7ff;
  --accent-blue: #00effd;
  --text-dark: #1a202c;
  --text-gray: #4a5568;
  --text-light: #718096;
  --bg-white: #ffffff;
  --bg-gray: #f7fafc;
  --bg-light: #edf2f7;
  --border-light: #e2e8f0;
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);
  --shadow-blue: 0 10px 30px rgba(18, 151, 239, 0.15);
  --shadow-blue-lg: 0 20px 40px rgba(18, 151, 239, 0.2);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;
}

/* Layout General */
.products-page {
  min-height: 100vh;
  background: var(--bg-white);
  font-family:
    'Inter',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Hero Section */
.hero-section {
  padding: 5rem 0 6rem;
  background: var(--bg-white);
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  /*   background: linear-gradient(135deg, rgba(18, 151, 239, 0.02) 0%, rgba(74, 183, 255, 0.05) 100%); */
  z-index: 0;
  border-radius: 0 0 0 100px;
}

.hero-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 1;
}

.hero-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6rem;
  align-items: center;
}

.hero-text {
  max-width: 600px;
}

.hero-title {
  font-size: clamp(2.5rem, 4vw, 4rem);
  font-weight: 800;
  color: var(--primary-blue);
  line-height: 1.1;
  margin-bottom: 2rem;
  letter-spacing: -0.02em;
}

.hero-description {
  font-size: clamp(1.2rem, 1.5vw, 1.4rem);
  color: var(--text-gray);
  line-height: 1.7;
  margin-bottom: 3rem;
  font-weight: 400;
}

.demo-link {
  text-decoration: none;
}

.btn-demo {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  padding: 20px 40px;
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  color: var(--bg-white);
  border: none;
  border-radius: var(--radius-xl);
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--shadow-blue);
  position: relative;
  overflow: hidden;
  text-transform: none;
  letter-spacing: 0.5px;
}

.btn-demo::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.btn-demo:hover::before {
  left: 100%;
}

.btn-demo:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-blue-lg);
  background: linear-gradient(135deg, var(--secondary-blue) 0%, var(--accent-blue) 100%);
}

.btn-demo:active {
  transform: translateY(-2px);
}

.btn-icon {
  font-size: 22px;
  transition: transform 0.3s ease;
}

.btn-demo:hover .btn-icon {
  transform: translateX(6px);
}

/* Hero Image */
.hero-image {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.platform-preview {
  position: relative;
  max-width: 650px;
  width: 100%;
}

.platform-screenshot {
  width: 100%;
  height: auto;
  /* border-radius: var(--radius-xl); */
  /*   box-shadow: var(--shadow-xl); */
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  /*   border: 1px solid var(--border-light); */
}

/* .platform-screenshot:hover {
  transform: scale(1.02) translateY(-8px);
  box-shadow: 0 30px 60px rgba(18, 151, 239, 0.15);
}
 */
.tech-background {
  position: absolute;
  top: -30px;
  right: -30px;
  width: 120%;
  height: 120%;
  /*   background: radial-gradient(circle at 30% 30%, rgba(18, 151, 239, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(74, 183, 255, 0.06) 0%, transparent 50%);
  border-radius: var(--radius-xl); */
  z-index: -1;
  filter: blur(1px);
}

/* Problem Section */
.problem-section {
  padding: 8rem 0;
  background: var(--bg-gray);
  position: relative;
}

.problem-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border-light), transparent);
}

.problem-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6rem;
  align-items: center;
}

.section-title {
  font-size: clamp(2.2rem, 3vw, 3rem);
  font-weight: 700;
  color: var(--text-dark);
  margin-bottom: 2rem;
  letter-spacing: -0.02em;
}

.section-title.centered {
  text-align: center;
  margin-bottom: 4rem;
}

.problem-question {
  font-size: 1.3rem;
  color: var(--text-gray);
  margin-bottom: 2.5rem;
  font-weight: 500;
  line-height: 1.6;
}

.problem-list {
  list-style: none;
  padding: 0;
  margin: 0;
  background: var(--bg-white);
  border-radius: var(--radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-light);
}

.problem-item {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem 0;
  font-size: 1.1rem;
  color: var(--text-dark);
  border-bottom: 1px solid var(--border-light);
  font-weight: 500;
}

.problem-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.problem-icon {
  font-size: 1.4rem;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(220, 53, 69, 0.1);
  border-radius: 50%;
}

.problem-visual {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 400px;
  background: var(--bg-white);
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
}

.excel-icon,
.paper-icon {
  font-size: 5rem;
  opacity: 0.6;
  position: absolute;
  filter: grayscale(0.3);
}

.excel-icon {
  top: 15%;
  left: 15%;
  animation: float 4s ease-in-out infinite;
}

.paper-icon {
  bottom: 15%;
  right: 15%;
  animation: float 4s ease-in-out infinite reverse;
}

.confusion-lines {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent 45%, rgba(220, 53, 69, 0.1) 50%, transparent 55%),
    linear-gradient(-45deg, transparent 45%, rgba(220, 53, 69, 0.1) 50%, transparent 55%);
  animation: pulse 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-25px) rotate(5deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
}

/* Features Section */
.features-section {
  padding: 8rem 0;
  background: var(--bg-white);
  position: relative;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2.5rem;
  margin-top: 4rem;
}

.feature-card {
  background: var(--bg-white);
  padding: 3rem 2rem;
  border-radius: var(--radius-xl);
  text-align: center;
  box-shadow: var(--shadow-md);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.feature-card:hover::before {
  transform: scaleX(1);
}

.feature-card:hover {
  transform: translateY(-12px);
  box-shadow: var(--shadow-xl);
  border-color: rgba(18, 151, 239, 0.2);
}

.feature-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  color: var(--bg-white);
  font-size: 2.2rem;
  box-shadow: var(--shadow-blue);
  transition: all 0.3s ease;
}

.feature-card:hover .feature-icon {
  transform: scale(1.1) rotate(5deg);
  box-shadow: var(--shadow-blue-lg);
}

.feature-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--text-dark);
  margin: 0;
  line-height: 1.4;
  letter-spacing: -0.01em;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-content,
  .problem-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .hero-section {
    padding: 6rem 0 4rem;
  }

  .hero-section::before {
    width: 100%;
    height: 50%;
    border-radius: 0 0 50px 50px;
  }

  .section-container {
    padding: 0 1.5rem;
  }

  .hero-container {
    padding: 0 1.5rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .btn-demo {
    padding: 18px 32px;
    font-size: 1rem;
    gap: 12px;
  }

  .platform-preview {
    order: -1;
  }

  .problem-visual {
    height: 300px;
  }

  .excel-icon,
  .paper-icon {
    font-size: 4rem;
  }

  .problem-list {
    padding: 1.5rem;
  }

  .feature-card {
    padding: 2.5rem 1.5rem;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2.2rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .feature-card {
    padding: 2rem 1.5rem;
  }

  .feature-icon {
    width: 70px;
    height: 70px;
    font-size: 1.8rem;
  }

  .btn-demo {
    padding: 16px 28px;
    font-size: 0.95rem;
  }

  .problem-question {
    font-size: 1.1rem;
  }

  .problem-item {
    font-size: 1rem;
    padding: 1.2rem 0;
  }
}

/* Mejoras adicionales */
.hero-title::after {
  content: '';
  display: block;
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  margin-top: 1rem;
  border-radius: 2px;
}

.section-title.centered::after {
  content: '';
  display: block;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  margin: 1rem auto 0;
  border-radius: 2px;
}

/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}

/* Focus states for accessibility */
.btn-demo:focus {
  outline: 2px solid var(--primary-blue);
  outline-offset: 2px;
}

.feature-card:focus-within {
  transform: translateY(-8px);
  box-shadow: var(--shadow-lg);
}
</style>
